import { Routes } from '@angular/router';
import { Home } from './components/home/home';
import { PhoneCases } from './components/phone-cases/phone-cases';
import { PhoneCaseDetails } from './components/phone-case-details/phone-case-details';
import { Orders } from './components/orders/orders';
import { Faqs } from './components/faqs/faqs';
import { TermAndConditions } from './components/term-and-conditions/term-and-conditions';
import { ShippingAndReturn } from './components/shipping-and-return/shipping-and-return';
import { OurStory } from './components/our-story/our-story';
import { PrivacyPolicy } from './components/privacy-policy/privacy-policy';
import { Checkout } from './components/checkout/checkout';
import { AboutUs } from './components/about-us/about-us';
import { ContactUs } from './components/contact-us/contact-us';
import { SelectionPage } from './components/selection-page/selection-page';
import { modelSelectionGuard } from './service/model-selection.guard';

export const routes: Routes = [
    { path: '', component: Home, title: 'Swevenne: Home' },
    { path: 'home', component: Home, title: 'Swevenne: Home' },
    { path: 'selection', component: SelectionPage, title: 'Swevenne: Brand and Model Selection' },
    { path: 'phone-cases', component: PhoneCases, title: 'Swevenne: Phone Cases', canActivate: [ modelSelectionGuard ] },
    { path: 'phone-case-details', component: PhoneCaseDetails, title: 'Swevenne: Phone Case Details', canActivate: [ modelSelectionGuard ] },
    { path: 'orders', component: Orders, title: 'Swevenne: Orders' },
    { path: 'faqs', component: Faqs, title: 'Swevenne: FAQs' },
    { path: 'privacy-policy', component: PrivacyPolicy, title: 'Swevenne: Privacy Policy' },
    { path: 'term-and-conditions', component: TermAndConditions, title: 'Swevenne: Terms and Conditions' },
    { path: 'shipping-and-return', component: ShippingAndReturn, title: 'Swevenne: Shipping and Return' },
    { path: 'our-story', component: OurStory, title: 'Swevenne: Our Story' },
    { path: 'checkout', component: Checkout, title: 'Swevenne: Checkout' },
    { path: 'about-us', component: AboutUs, title: 'Swevenne: About Us' },
    { path: 'contact-us', component: ContactUs, title: 'Swevenne: About Us' },
    { path: '**', redirectTo: 'home' }
];
